<template>
  <div
    class="sticky-bottom-bar-icons"
    :style="{ gridTemplateColumns: `repeat(${buttonsCount}, 1fr)` }"
  >
    <button
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="$emit('cancel')"
    >
      <div class="mobile-bar-btn-content">
        <i class="feather icon-x mobile-bar-icon"></i>
        <span class="mobile-btn-label">{{ $t('$General.Close') }}</span>
      </div>
    </button>

    <button
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="$emit('save')"
    >
      <div class="mobile-bar-btn-content">
        <i class="feather icon-save mobile-bar-icon"></i>
        <span class="mobile-btn-label">{{ $t('$General.SaveAndQuit') }}</span>
      </div>
    </button>

    <button
      v-if="wizardProps.activeTabIndex > 0"
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="prevStep"
    >
      <div class="mobile-bar-btn-content">
        <i class="feather icon-arrow-left mobile-bar-icon"></i>
        <span class="mobile-btn-label">{{ $t('$General.Back') }}</span>
      </div>
    </button>

    <button
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="nextStep"
    >
      <div class="mobile-bar-btn-content">
        <i
          class="feather mobile-bar-icon"
          :class="wizardProps.isLastStep ? 'icon-check' : 'icon-arrow-right'"
        ></i>
        <span class="mobile-btn-label">{{ $t(`$General.${wizardProps.isLastStep ? 'Done' : 'Continue'}`) }}</span>
      </div>
    </button>
  </div>
</template>

<script>
/**
 * Reviews settings create or edit wizard buttons
 *
 * @module views/modules/reviews/ReviewsSettingsCreateOrEditWizardButtons
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-prop {Object} wizardProps - wizard props
 */
export default {
  name: 'WaitingListConfigurationWizardButtons',
  components: {},
  props: {
    wizardProps: {
      type: Object,
      required: true,
    },
    configTemplatesTabIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    buttonsCount() {
      // Close + Save & quit + Continue/Done are always visible; Back is conditional
      return 3 + (this.wizardProps.activeTabIndex > 0 ? 1 : 0);
    },
  },
  methods: {
    nextStep() {
      if (this.wizardProps.activeTabIndex === 1 && this.configTemplatesTabIndex < 6) {
        this.$emit('next-config-temp-step');
      } else {
        this.wizardProps.nextTab();
      }
    },
    prevStep() {
      if (this.wizardProps.activeTabIndex === 1 && this.configTemplatesTabIndex > 0) {
        this.$emit('prev-config-temp-step');
      } else {
        this.wizardProps.prevTab();
      }
    },
  },
};
</script>
